module.exports = __webpack_public_path__ + "static/media/contact.791ebac8.jpg";